import { FieldValues } from "react-hook-form";

import { BaseFormInputPropsType, VnFormInput } from "../VnForm";
import { BaseSelectInput, BaseSelectInputPropsType } from "./BasePicker";

type VnPickerPropsType<T extends FieldValues> = BaseFormInputPropsType<T> &
  BaseSelectInputPropsType;

export const VnPicker = <T extends FieldValues>({
  ...props
}: VnPickerPropsType<T>) => {
  return (
    <VnFormInput {...props}>
      {({ field, hasError }) => (
        <BaseSelectInput
          isDisabled={props.isDisabled}
          hasError={hasError}
          {...field}
          {...props}
        />
      )}
    </VnFormInput>
  );
};
